import { Link } from "react-router-dom";

const LINK_GROUPS = [
  {
    title: "浏览",
    links: [
      { to: "/movies", label: "电影频道" },
      { to: "/tvseries", label: "电视剧频道" },
      { to: "/news", label: "影视资讯" },
      { to: "/search", label: "搜索影视" },
    ],
  },
  {
    title: "关于",
    links: [
      { to: "/about", label: "关于白虎" },
      { to: "/favorites", label: "我的收藏" },
      { to: "/about", label: "联系我们" },
      { to: "/about", label: "版权声明" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg text-accent-400">
                <i className="ri-movie-2-fill"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="text-lg font-black tracking-tight text-foreground-950">
                  白虎影视
                </span>
                <span className="font-label text-[10px] tracking-[0.28em] text-accent-600">
                  BAIHU VIDEO
                </span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              白虎是一个综合影视内容展示平台，汇聚电影与电视剧的分类浏览、剧情介绍与影视资讯，
              帮助你在观影前快速了解作品信息。本站不提供在线播放与下载服务。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-mail-fill"].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-lg text-foreground-600"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>

          {LINK_GROUPS.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-950">{group.title}</h4>
              <ul className="mt-4 space-y-3">
                {group.links.map((link) => (
                  <li key={`${group.title}-${link.label}`}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 transition-colors hover:text-accent-600"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-sm text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 白虎影视平台 · 本站内容仅供演示，搜索与收藏均为前端演示功能</p>
          <p className="flex items-center gap-2">
            <i className="ri-information-line"></i>
            不提供播放、下载、会员及支付服务
          </p>
        </div>
      </div>
    </footer>
  );
}